export default "__VITE_PUBLIC_ASSET__fd08c971__"